const { default: BecomeExpertApplyComponent } = require("../../components/become-expert/become-expert-apply");

const BecomeExpertEditPage = () => <BecomeExpertApplyComponent />

export default BecomeExpertEditPage;